var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.59998 7.19961c0-1.98823 1.61177-3.6 3.6-3.6h12.00002c.4545 0 .87.2568 1.0733.66334s.1594.89304-.1133 1.25666l-3.06 4.08 3.06 4.07999c.2727.3636.3166.8501.1133 1.2567-.2033.4065-.6188.6633-1.0733.6633h-12.00002c-.66275 0-1.2.5373-1.2 1.2v3.6c0 .6628-.53726 1.2-1.2 1.2-.66275 0-1.2-.5372-1.2-1.2z",
    fill: "#5a34e1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.048d3ffac74c1bf52f7b561f7e9df781.svg";
export { ForwardRef as ReactComponent };